export interface Category {
  name: string;
  slug: string;
  url: string;
}

export const categories: Category[] = [
  { name: 'Shoes', slug: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', slug: 'Hoodies-Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
  { name: 'T-Shirts', slug: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
  { name: 'Jackets', slug: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
  { name: 'Pants/Shorts', slug: 'Pants-Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
  { name: 'Headwear', slug: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
  { name: 'Sets', slug: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
  { name: 'Underwear/Underpants', slug: 'underwear-underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
  { name: 'Jersey', slug: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
  { name: 'Accessories', slug: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
  { name: 'Bags', slug: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
  { name: 'Belts', slug: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html' },
  { name: 'Perfumes', slug: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html' },
  { name: 'OtherStuff', slug: 'OtherStuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html' },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';